<template>
  <div class="common-content account">
    <a-breadcrumb separator=">" class="common-breadcrumb">
      <a-breadcrumb-item>系统管理</a-breadcrumb-item>
      <a-breadcrumb-item>登录日志</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="common-search">
      <div class="search-form">
        <a-form-model :model="form1" layout="inline" :wrapper-col="{span:24}" labelAlign="left" :colon="false" hideRequiredMark>
          <a-form-model-item label="操作人">
            <a-input v-model="form1.name" placeholder="请输入" />
          </a-form-model-item>
          <a-form-model-item label="时间">
            <a-range-picker v-model="form1.time" :default-value="[moment(start, dateFormat), moment(end, dateFormat)]" :format="dateFormat" :disabled-date="disabledDate" @change="changeTime" />

          </a-form-model-item>
        </a-form-model>
      </div>
      <div class="query-btn" @click="query(1,pageSize)">
        <span class="query-title">查询</span>
      </div>
    </div>
    <div class="common-table">
      <a-table :class="{'my-table-none':isLoad}" :columns="columns" :data-source="tableData" rowKey="id" :pagination="false" tableLayout="fixed">
      </a-table>
      <z-pagination @change="pageChange" :currentPage.sync="page" :total="total" :page-size="pageSize"></z-pagination>
    </div>
    <a-spin :spinning="isLoad" v-show="isLoad" class="common-load" />
  </div>
</template>
<script>
import Pagination from "@/components/Pagination.vue";
import moment from 'moment';
export default {
  components: {
    "z-pagination": Pagination,
  },
  data() {
    const time = new Date()
    const end = moment().format('YYYY-MM-DD')
    const start = moment().add('days', -7).format('YYYY-MM-DD')
    return {
      dateFormat: 'YYYY-MM-DD',
      end,
      start,
      time,
      isLoad: false,
      btnLoading: false,
      total: 0,
      page: 1,
      pageSize: 8,
      form1: {
        name: "",
        state: "",
        time: [start, end]
      },

      columns: [
        {
          title: "操作人",
          dataIndex: "userrealname",
        },
        {
          title: "操作类型",
          align: "center",
          dataIndex: "type",
          customRender: (text) => {
            return text == 1
              ? "登入"
              : text == 2
                ? "登出" : "--";
          },
        },
        {
          title: "操作时间",
          align: "center",
          dataIndex: "logintime",
          customRender: (text) => {
            return text.substring(0, 19);
          },
        },
      ],
      tableData: [],

      form2: {},
      visible2: false,
    };
  },
  mounted() {
    this.form1.endtime = this.end+ " 23:59:59";
    this.form1.starttime = this.start+ " 00:00:00";
    this.query(this.page, this.pageSize);
  },
  methods: {
    moment,
    disabledDate(current) {
      // Can not select days before today and today
      return current && !(current < moment().endOf('day'));
    },
    changeTime(val, dateString) {
      if (dateString&& dateString.length > 0) {
        if (dateString[0] != '') {
          this.form1.starttime = dateString[0] + " 00:00:00";

        } else {
          this.form1.starttime = undefined
        }
        if (dateString[1] != '') {
          this.form1.endtime = dateString[1] + " 23:59:59";
        } else {

          this.form1.endtime = undefined
        }
      }
    },
    // 给表格特定行添加类
    rowClassName(record, index) {
      if (index % 2 == 1) {
        return "special-table-row";
      }
    },
    // 查询
    query(nowPage, nowPageCount) {
      let _this = this;
      // 请求对象
      let params = new URLSearchParams();
      // 填充参数
      if (this.form1.name) params.append("name", _this.form1.name);
      if (this.form1.starttime) params.append("starttime", _this.form1.starttime);
      if (this.form1.endtime) params.append("endtime", _this.form1.endtime);
      params.append("nowPage", nowPage);
      params.append("nowPageCount", nowPageCount);
      _this.isLoad = true;
      _this
        .$axios({
          url: "/pc/loginLog/selectAll",
          method: "get",
          params: params,
        })
        .then((res) => {
          if (res.data.state == 1) {
            _this.tableData = res.data.data.records;
            if (_this.tableData.length == 0 && nowPage > 1) {
              _this.query(1, nowPageCount);
            } else {
              _this.total = res.data.data.total;
              _this.page = nowPage;
              _this.pageSize = res.data.data.size;
            }
          } else {
            _this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          _this.isLoad = false;
        });
    },

    // 改变当前页
    pageChange(currentPage, pageSize) {
      this.query(currentPage, pageSize);
    },
  },
};
</script>
<style lang="scss">
.account-modal {
  .password-tip {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(197, 208, 215, 1);
  }
}


.common-content {
  position: relative;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
}
.nav-page {
  cursor: pointer;
}
.common-breadcrumb.ant-breadcrumb {
  height: 50px;
  background: rgba(114, 190, 255, 0.15);
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 50px;
  color: rgb(51, 97, 143);
  text-align: left;
  padding: 0 20px;
  .nav-page {
    cursor: pointer;
  }
}
.common-search {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 40px 20px 20px 20px;
  padding-top: 40px; /*no*/
  .search-form {
    position: relative;
    .ant-form-item-label {
      position: absolute;
      top: -100%;
      left: 0;
      font-size: 14px; /*no*/
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgb(51, 97, 143);
      label {
        color: rgb(51, 97, 143);
      }
    }
    .ant-form-item {
      margin: 0;
      margin-right: 40px;
      min-width: 200px;
      .ant-select {
        min-width: 200px;
      }
      .ant-calendar-picker {
        width: 100%;
      }
    }
    //查询条件中日期范围
    .search-range.ant-calendar-picker {
      width: 300px !important;
    }
    .ant-cascader-picker-label {
      color: rgb(51, 97, 143);
    }
  }
  // 查询按钮
  .query-btn {
    position: relative;
    width: 66px; /*no*/
    height: 28px; /*no*/
    background: #10abf9;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2px; /*no*/
    cursor: pointer;
    user-select: none;
    .query-title {
      height: 14px; /*no*/
      line-height: 14px; /*no*/
      font-size: 14px; /*no*/
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgb(255, 255, 255);
    }
  }
  .query-btn:active::before {
    display: block;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(236, 229, 229, 0.2);
  }
  // 添加按钮
  .add-btn {
    position: relative;
    margin-left: auto;
    width: 66px; /*no*/
    height: 28px; /*no*/
         background:#10abf9;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2px; /*no*/
    cursor: pointer;
    user-select: none;
    .add-icon {
      width: 14px; /*no*/
      height: 14px; /*no*/
      display: flex;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .add-title {
      margin-left: 4px; /*no*/
      height: 14px; /*no*/
      line-height: 14px; /*no*/
      font-size: 14px; /*no*/
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgb(255, 255, 255);
    }
  }
  .add-btn:active::before {
    display: block;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(236, 229, 229, 0.2);
  }
}
.common-table {
  flex: 1;
  overflow-y: auto;
  .ant-table {
    .ant-table-thead > tr > th {
      color: rgba(51, 97, 143, 1);
      background: rgba(51, 97, 143, 0.05);
      font-weight: bold;
    }
    .ant-table-thead {
      tr {
        th:first-child {
          padding-left: 0;
        }
      }
      th {
        // text-align: center;
        box-sizing: border-box;
        span {
          display: block;
        }
        &:first-child > span {
          padding-left: 50px;
        }
      }
    }
    .ant-table-tbody {
      tr {
        cursor: pointer;
      }
      td {
        // text-align: center;
        &:first-child {
          padding-left: 50px;
        }
      }
    }
    .ant-table-placeholder {
      background: transparent;
    }
  }
  .special-table-row {
    background: rgba(51, 97, 143, 0.05);
  }
  // 表格删除
  .del-btn {
    margin-left: 10px;
    color: rgba(255, 121, 119, 1);
    user-select: none;
    cursor: pointer;
  }
  // 表格修改
  .edit-btn {
    margin-left: 10px;
    color: rgba(85, 167, 141, 1);
    user-select: none;
    cursor: pointer;
  }
  // 表格重置密码
  .reset-btn {
    margin-left: 10px;
    color: rgba(114, 190, 255, 1);
    user-select: none;
    cursor: pointer;
  }
  // 表格冻结
  .freeze-btn {
    margin-left: 10px;
    color: rgba(93, 145, 205, 1);
    user-select: none;
    cursor: pointer;
  }
  // 表格解冻
  .thaw-btn {
    margin-left: 10px;
    color: rgba(90, 220, 156, 1);
    user-select: none;
    cursor: pointer;
  }
  // 表格不同状态
  .special-table-col-1,
  .special-table-col-2,
  .special-table-col-3,
  .special-table-col-4 {
    cursor: pointer;
    user-select: none;
    display: inline-block;
    text-align: center;
    line-height: 28px;
    min-width: 145px;
    padding-left: 10px;
    padding-right: 10px;
    height: 28px;
    border-radius: 14px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
  }
  // 已到期
  .special-table-col-1 {
    color: rgba(255, 192, 0, 1);
    background: rgba(255, 215, 92, 0.3);
  }
  .special-table-col-2 {
    color: rgba(114, 190, 255, 1);
    background: rgba(114, 190, 255, 0.3);
  }
  // 已冻结
  .special-table-col-3 {
    color: rgba(51, 97, 143, 1);
    background: rgba(51, 97, 143, 0.3);
  }
  // 正常
  .special-table-col-4 {
    color: rgba(90, 220, 156, 1);
    background: rgba(90, 220, 156, 0.3);
  }
  .special-table-col-1:active,
  .special-table-col-2:active,
  .special-table-col-3:active,
  .special-table-col-4:active {
    opacity: 0.5;
  }
}
.common-modal {
  .ant-modal {
    height: 80%;
    top: 10%;
    padding-bottom: 0;
    .ant-modal-content {
      max-height: 100%;
      display: flex;
      flex-direction: column;
      .ant-modal-header {
        .ant-modal-title {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: rgb(51, 97, 143);
        }
      }
      .ant-modal-body {
        flex: 1;
        overflow-y: auto;
        .long-item.ant-form-item {
          flex: 0 0 100%;
          .ant-form-item-control {
            line-height: 100%;
          }
        }
        .ant-form-item-label > label {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(51, 97, 143, 1);
        }
        .ant-input {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(51, 97, 143, 1);
        }
        .ant-select-selection-selected-value {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(51, 97, 143, 1);
        }
        .ant-time-picker {
          width: 100%;
        }
        .ant-calendar-picker {
          width: 100%;
        }
      }
      .ant-modal-footer {
        border-top: none;
        padding: 10px 30px !important; /*no*/
        .ok-btn {
          width: 66px; /*no*/
          height: 28px; /*no*/
          font-size: 14px; /*no*/
          background: rgba(85, 167, 141, 1);
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          user-select: none;
          cursor: pointer;
        }
        .cancel-btn {
          width: 66px; /*no*/
          height: 28px; /*no*/
          font-size: 14px; /*no*/
          font-family: Microsoft YaHei;
          font-weight: 400;
          user-select: none;
          cursor: pointer;
        }
      }
    }
  }
}
.common-load {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
}
.head-office {
  #amap2 {
    height: 100%;
    width: 100%;
  }
  .panel1 {
    position: absolute;
    top: 20px;
    right: 16px;
    width: 320px;
    background: rgba(30, 45, 72, 0.8);
    box-shadow: 0px 0px 6px rgba(114, 190, 255, 1);
    border-radius: 10px;
    .panel1-search {
      border-bottom: 1px solid #8ab0d6; /*no*/
      height: 50px; /*no*/
      display: flex;
      align-items: center;
      padding: 0 30px;
      .ant-input {
        color: #fff;
        background: #425978;
        border: none;
      }
      .ant-input-group-addon {
        padding-left: 15px;
        background: transparent;
        .ant-btn {
          background-color: #55a78d;
          color: #fff;
          border: none;
        }
        .ant-btn:hover {
          opacity: 0.9;
        }
      }
    }
    .panel1-body {
      height: 360px;
      overflow: auto;

      .panel1-body-tr {
        cursor: pointer;
        user-select: none;
        height: 40px; /*no*/
        line-height: 40px; /*no*/
        padding: 0 30px;
        font-size: 12px; /*no*/
        font-family: Microsoft YaHei;
        color: #fff;
        text-align: left;
      }
      .panel1-body-nodata {
        text-align: center;
        height: 80px; /*no*/
        line-height: 80px; /*no*/
      }
      .bg-tr {
        background: rgba(114, 190, 255, 0.15);
      }
      .bg-tr-select {
        background: #72beff;
      }
    }
  }
}
.head-office-modal {
  .ant-modal {
    width: 80% !important;
    height: 80%;
    .ant-modal-close {
      top: -36px;
      right: -30px;
      .ant-modal-close-x {
        width: 30px;
        height: 30px;
        line-height: 30px;
        border-radius: 50%;
        font-size: 18px;
        background: #fff;
        font-weight: bold;
        .anticon {
          font-weight: bold;
          color: #000;
        }
      }
    }
    .ant-modal-header {
      display: none;
    }
    .ant-modal-body {
      padding: 0;
      display: flex;
      flex-direction: column;
    }
  }
  .z-modal-con {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    .ant-collapse {
      border: none;
      background-color: #fff;
      .ant-collapse-item {
        border: none;
        background-color: rgba(255, 255, 255, 1);
        box-shadow: 5px 0px 6px rgba(108, 115, 146, 0.15);
        .ant-collapse-header {
          text-align: left !important;
          height: 40px;
          line-height: 40px;
          padding: 0 0 0 30px;
          background: rgba(85, 167, 141, 0.1);
          color: rgba(85, 167, 141, 1);
          font-weight: bold;
          text-indent: 1.5em;
          .icon-close {
            width: 16px;
            height: 2px;
          }
          .icon-open {
            width: 16px;
            height: 16px;
          }
          .header-title {
            display: flex;
            align-items: center;
            .icon-title {
              width: 14px;
              height: 14px;
              margin-right: 5px;
            }
          }
        }
        .ant-collapse-content {
          background-color: #fff;
        }
      }
    }

    .line {
      height: 10px;
      background-color: rgba(240, 242, 245, 1);
    }

    .panel-body {
      display: flex;
      flex-wrap: wrap;
      text-align: left;
      .item {
        height: 100px; /*no*/
        width: 25%;
        padding: 20px;
        .label,
        .value {
          height: 30px; /*no*/
          line-height: 30px; /*no*/
          font-size: 14px; /*no*/
          &.label {
            color: rgba(51, 97, 143, 1);
          }
          &.value {
            background-color: rgba(114, 190, 255, 0.13);
            border-radius: 4px;
            text-indent: 0.5em;
          }
          span {
            font-size: 14px; /*no*/
          }
        }

        &.audio {
          .value {
            height: 28px; /*no*/
            background-color: rgba(85, 167, 141, 1);
            border-radius: 5px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
            user-select: none;
            .text {
              color: #fff;
            }
            .icon {
              width: 15px; /*no*/
              height: 15px; /*no*/
              margin-right: 20px;
            }
          }
        }
      }
      .item-half {
        width: 50%;
        padding: 20px;
        .label {
          height: 30px; /*no*/
          line-height: 30px; /*no*/
          font-size: 14px; /*no*/
          color: rgba(51, 97, 143, 1);
        }
        .value {
          background-color: rgba(114, 190, 255, 0.13);
          border-radius: 4px;
          padding: 10px;
          .icon-scene {
            width: 170px;
            height: 110px;
            margin-left: 10px;
            cursor: pointer;
          }
          span {
            font-size: 14px; /*no*/
          }
        }
      }

      .item-long {
        width: 100%;
        padding: 20px;
        .label {
          height: 30px; /*no*/
          line-height: 30px; /*no*/
          font-size: 14px; /*no*/
          color: rgba(51, 97, 143, 1);
        }

        .value {
          padding: 20px;
          font-size: 14px; /*no*/
          background-color: rgba(114, 190, 255, 0.13);
          border-radius: 4px;
          min-height: 100px; /*no*/
          span {
            font-size: 14px; /*no*/
          }
        }
      }
    }
  }
  .back-con {
    position: relative;
  }
  .back-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 20px;
    margin-left: auto;
    width: 66px;
    height: 28px;
    background: rgb(85, 167, 141);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2px; /*no*/
    cursor: pointer;
    user-select: none;
    .back-icon {
      width: 14px;
      height: 14px;
      display: flex;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .back-title {
      margin-left: 4px;
      height: 14px;
      line-height: 14px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgb(255, 255, 255);
    }
  }
  .back-btn:active::before {
    display: block;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(236, 229, 229, 0.2);
  }
}
.head-office-modal.speacial-modal {
  .ant-modal-content {
    height: 100%;
  }
}
</style>